module.exports = __webpack_public_path__ + "static/media/plane-arrival.aaf14f6c.svg";